import { useMemo, useState } from 'react';
import DataRegistry from "../classes/DataRegistry.js";
/** Hook that returns an API equivalent to DataRegistry but which updates as needed for use as a hook. */
export default function useDataRegistry() {
  const [, forceUpdate] = useState(Math.random());
  const privateRegistry = useMemo(() => new DataRegistry(), []);
  return useMemo(() => ({
    registerData: function () {
      privateRegistry.registerData(...arguments);
      forceUpdate(Math.random());
    },
    unregisterData: function () {
      privateRegistry.unregisterData(...arguments);
      forceUpdate(Math.random());
    },
    entries: () => privateRegistry.entries(),
    get: key => privateRegistry.get(key),
    keys: () => privateRegistry.keys()
  }), [privateRegistry]);
}